import { usePasswordInputContext } from '@ark-ui/react/password-input'

import { HelperText, type HelperTextProps } from '~/components/helper-text'

type InputPasswordHelperTextProps = Pick<HelperTextProps, 'prefix'> & {
  children: React.ReactNode
  readOnly?: boolean
}

export function InputPasswordHelperText({
  children,
  readOnly,
  ...props
}: InputPasswordHelperTextProps) {
  const { invalid, disabled } = usePasswordInputContext()

  return (
    <HelperText
      {...props}
      isError={invalid}
      isDisabled={disabled}
      isReadOnly={readOnly}
    >
      {children}
    </HelperText>
  )
}

InputPasswordHelperText.displayName = 'InputPasswordHelperText'
